import React from 'react';
import { Award, Globe, Star, Target } from 'lucide-react';
import { Card } from './ui/card';

const About = () => {
  const highlights = [
    {
      icon: Award,
      title: '6x National Champion',
      description: 'Six-time Bulgarian National Figure Skating Champion'
    },
    {
      icon: Globe,
      title: 'International Experience',
      description: 'Competed at European & World Championships'
    },
    {
      icon: Star,
      title: 'Elite Training',
      description: 'Trained by world-renowned coaches including Rafael Arutyunyan'
    },
    {
      icon: Target,
      title: 'Professional Coach',
      description: 'Expert in technique, artistry, and competition preparation'
    }
  ];

  return (
    <section id="about" className="py-24 bg-slate-800">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Column */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_ice-maestro/artifacts/5e1be5ta_pic.jpg"
                alt="Hristina Vassileva"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-slate-900/10 rounded-2xl"></div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-sky-100 to-sky-50 rounded-2xl -z-10"></div>
          </div>

          {/* Content Column */}
          <div>
            <div className="inline-block px-4 py-2 bg-sky-600 text-white rounded-full text-sm font-semibold mb-6">
              About Hristina
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              From International Competitor to Elite Coach
            </h2>
            
            <div className="space-y-4 text-slate-300 text-lg leading-relaxed mb-8">
              <p>
                Born in Sofia, Bulgaria, Hristina Vassileva-Zhecheva is a former competitive figure skater who represented Bulgaria on the international stage for over a decade.
              </p>
              <p>
                As a six-time Bulgarian National Champion, she competed at multiple ISU Championships including European Championships, World Championships, and World Junior Championships, achieving her best European Championship result of 16th place in 2001.
              </p>
              <p>
                After retiring from competitive skating in 2017, Hristina transitioned into coaching and choreography, bringing her wealth of international experience and elite training background to developing the next generation of figure skating champions.
              </p>
              <p>
                Her coaching philosophy combines European discipline and technical precision with modern American training methods, creating a comprehensive approach that develops both athletic excellence and artistic expression.
              </p>
            </div>

            {/* Highlights Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {highlights.map((item, index) => {
                const Icon = item.icon;
                return (
                  <Card key={index} className="p-4 bg-slate-700 border-slate-600 hover:border-sky-400 transition-colors duration-300">
                    <div className="flex items-start space-x-3">
                      <div className="bg-sky-600 p-2 rounded-lg">
                        <Icon className="w-5 h-5 text-white" />
                      </div>
                      <div className="flex-1">
                        <h3 className="font-semibold text-white mb-1">{item.title}</h3>
                        <p className="text-sm text-slate-300">{item.description}</p>
                      </div>
                    </div>
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;